export { IIMRImage, IMRImageOptions, IMRImageInitializedArgs } from './image.interfaces'
export { IMAGE_MODULE_NAME } from './image.module'